<template>
    <div class="sub-project-types">
        <div class="row">
            
            <div :class="{'col-lg-6': !selectedRow, 'col-lg-3': selectedRow}">
                <div class="placeholder fit-content">
                    <div class="placeholder__heading">
                        <!--<d-tooltip placement="left" identifier="enterprise.mainProjectType" />-->
                        Underentrepriser
                    </div>
                    <div class="placeholder">
                        
                        <vue-good-table
                            :columns="columns"
                            :rows="rows"
                            :search-options="searchOptions"
                            :pagination-options="paginationOptions"
                            :sort-options="sortOptions"
                            :styleClass="styleClass"
                            @on-row-click="selectSubProjectType"
                            :row-style-class="selectedRowClass"
                            v-if="!loading"
                        >
                            <div slot="emptystate">
                                Ingen data ...
                            </div>
                            <template slot="table-row" slot-scope="props">
                                <div class="coverage-cell" v-if="props.column.field == 'coverage_percent'">
                                    {{ props.row.coverage_percent | coveragePercent }} 
                                    <div
                                        v-if="props.row.coverage_percent !== null"
                                        class="coverage-indicator"
                                        :class="{'bad': props.row.coverage_percent < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                                    />
                                </div>
                                <div v-else-if="props.column.field == 'name'" class="table-column__description" :title="props.row.name ? props.row.name : '-'">
                                    {{ props.row.name ? props.row.name : '-' }}
                                </div>
                                <div v-else-if="props.column.field == 'coverage'">
                                    {{ props.row.coverage | currency }}
                                </div>
                                <div v-else-if="props.column.field == 'invoices_total'">
                                    {{ props.row.invoices_total | currency }}
                                </div>
                                <div class="coverage-cell" v-else-if="props.column.field == 'coverage_per_hour'">
                                    {{ props.row.coverage_per_hour | currency }} 
                                    <div
                                        v-if="props.row.coverage_per_hour !== null"
                                        class="coverage-indicator"
                                        :class="{'bad': props.row.coverage_per_hour < $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.high.value}"
                                    />
                                </div>
                                <div v-else-if="props.column.field == 'budget'">
                                    -
                                </div>
                                <div v-else-if="props.column.field == 'efficiency'">
                                    -
                                </div>
                                <div v-else-if="props.column.field == 'total_expenses'">
                                    {{ props.row.total_expenses | currency }}
                                </div>
                                <div v-else-if="props.column.field == 'sub_projects_total_expenses'">
                                    {{ props.row.sub_projects_total_expenses | currency }}
                                </div>
                                <div v-else :title="props.formattedRow[props.column.field]">
                                    {{ props.formattedRow[props.column.field] }}
                                </div>
                            </template>
                        </vue-good-table>

                        <box-loading height="350" v-else />

                    </div>
                </div>
            </div>
            
            <div :class="{'col-lg-6': !selectedRow, 'col-lg-9': selectedRow}">
                
                <div v-if="!selectedRow">
                    Vælg en underentreprise for at se en liste over alle opgaver inden for denne type
                </div>

                <div v-if="selectedRow">
                    <div style="margin-bottom:5px;">
                        <a href="javascript:void(0)" @click="selectedRow = null" style="text-decoration:none;color:#172b43;font-weight:600;">
                            <i class="far fa-times" /> Luk
                        </a>
                    </div>
                </div>

                <sub-project-types-single :data="selectedRow" v-if="selectedRow" />

            </div>

        </div>
    </div>
</template>

<script>
import * as mainProjectService from '@/services/mainProjectService'

export default {
    data () {
        return {
            selectedRow: null,
            loading: true,
            rows: [],
            columns: [
                { label: 'Navn', field: 'name' },
                { label: 'Antal', field: 'sub_projects_count', type: 'number' },
                { label: 'Budget omk.', field: 'budget' },
                { label: 'Realiseret', field: 'total_expenses', type: 'number' },
                { label: 'Eff. grad', field: 'efficiency' }
            ],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true
            },
            styleClass: 'vgt-table'
        }
    },
    created () {
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            this.$emit('finishedLoading', null)
            this.selectedRow = null
            let params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid
            }
            mainProjectService.subProjectTypes(params, (response) => {
                this.rows = response.data
                this.loading = false
                this.$emit('finishedLoading', this.rows.length)
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        },
        selectSubProjectType (subProjectType) {
            this.selectedRow = subProjectType.row
        },
        selectedRowClass (row) {
            if (this.selectedRow && row.name === this.selectedRow.name) {
                return 'selected'
            }
        }
    },
    components: {
        'sub-project-types-single': require('./subProjectTypesSingle.vue')
    },
    computed: {
        globalParams () {
            let startDate = this.$store.getters.getStartDate
            let endDate = this.$store.getters.getEndDate
            let department = this.$store.getters.getCurrentDepartment.uuid
            return startDate + endDate + department
        }
    },
    watch: {
        globalParams: function () {
            this.getData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// subProjectTypes.vue?9669ee9e